export default __webpack_public_path__ + "static/media/report.948d5874.png";